import Vue from 'vue';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';

import { CoreLoginPanelProvider } from 'core-login-panel';
import { CoreInputValidatorsProvider } from 'core-input-validators';

import TokenService from '@/services/TokenService';
import UserService from '@/services/UserService';
import { MutationTypes } from '@/store/user/types';
import { ProcessEnvType } from '@/Types/ProcessEnvType';

import '@/plugins/Pwr/CommonComponents';

import App from './App.vue';
import router from './router';
import store from './store';

import './scss/app.scss';

import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';

import api from './common/api/api';
import tokenInterceptor from './common/interceptors/token.interceptor';
import errorInterceptor from './common/interceptors/error.interceptor';
import langInterceptor from './common/interceptors/lang.interceptor';

errorInterceptor(api);
tokenInterceptor(api);
langInterceptor(api);

Vue.config.productionTip = false;
Vue.prototype.window = window;

// Creates side effects in i18n
CoreLoginPanelProvider.mergeLocales(i18n);
CoreInputValidatorsProvider.mergeLocales(i18n);

/** Icons
 * @see(https://www.npmjs.com/package/@fortawesome/vue-fontawesome)
 */
Vue.component('font-awesome-icon', FontAwesomeIcon); // Icon component
Vue.component('font-awesome-icon', FontAwesomeIcon); // Icon component
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App)
}).$mount('#app');

if (TokenService.getToken() !== null) {
  UserService.fetchUserData().then((user) => {
    store.commit(`user/${MutationTypes.SET_LOGGED_USER}`, user);
  });
}

// Fix gdzie użytkownicy wpisują kropkę po pl w url
// co sprawi że vue nie ogarnia i nie można ich z autoryzować

const env: ProcessEnvType = process.env as ProcessEnvType;
const appUrl = env.VUE_APP_URL;

if (window.location.href.includes(`${appUrl}./`)) {
  const url = window.location.href.replace(`${appUrl}./`, `${appUrl}/`);
  window.location.replace(url);
}
